import * as types from '@/store/mutations-types.js'

const state = {
  faqDialog: false // 新增弹窗
}

const action = {

}

const mutations = {
  [types.FAQ_DIALOG] (state, faqDialog) {
    state.faqDialog = faqDialog
  }
}

export default {
  state,
  action,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/help/faq.js